export default {
  customerFirstName: {
    component: 'adivare-default-form-element',
    formType: 'text',
    autocomplete: 'given-name',
    translationKey: 'customerFirstName',
    minlength: 1,
    maxlength: 35,
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full md:col-span-4',
  },
  customerLastName: {
    component: 'adivare-default-form-element',
    formType: 'text',
    autocomplete: 'family-name',
    translationKey: 'customerLastName',
    minlength: 1,
    maxlength: 35,
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full md:col-span-4',
  },
  customerPostcode: {
    component: 'adivare-address-form-element',
    formType: 'text',
    autocomplete: 'postal-code',
    translationKey: 'customerPostcode',
    minlength: 4,
    maxlength: 7,
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-4 md:col-span-2',
  },
  customerHouseNumber: {
    component: 'adivare-address-form-element',
    translationKey: 'customerHouseNumber',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-4 md:col-span-2',
  },
  customerHouseNumberExtension: {
    component: 'adivare-address-form-element',
    formType: 'text',
    outerClass: 'hidden',
    autocomplete: 'none',
  },
  customerCity: {
    component: 'adivare-address-form-element',
    formType: 'text',
    translationKey: 'customerCity',
    inputClass: 'flex flex-col form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-8 md:col-span-4',
  },
  customerStreet: {
    component: 'adivare-address-form-element',
    formType: 'text',
    translationKey: 'customerStreet',
    inputClass: 'flex flex-col form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-8',
  },
  customerEmail: {
    component: 'adivare-email-form-element',
    formType: 'email',
    autocomplete: 'email',
    translationKey: 'customerEmail',
    inputClass: 'form--texttype border-1 border-form-border-dark-grey placeholder-gray-400',
    legendClass: 'font-normal !text-slate-600',
    outerClass: 'block col-span-full',
    maxlength: 255,
  },
};
